import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import { SIZES } from 'common/constants/sizes';
import { multiLineEllipsis } from 'common/utils/text.utils';

export const HyperLink = styled.a`
  text-decoration: none;
  color: ${({ color }) =>
    color ? `${getColor(color)}` : `${getColor('chambray', 0.8)}`};
  font-size: ${({ size }) => (size ? SIZES[size] : SIZES.large)};
  ${props => (props.cursor ? `cursor: ${props.cursor}` : 'cursor: pointer')};
  &:hover {
    color: ${({ color }) =>
      color ? `${getColor(color)}` : `${getColor('chambray')}`};
  }
  ${({ multiLineEllipsisAfter }) =>
    multiLineEllipsisAfter ? multiLineEllipsis(multiLineEllipsisAfter) : ''};
  ${({ mb }) => (mb ? `margin-bottom: ${mb}` : '')};
  ${({ mt }) => (mt ? `margin-top: ${mt}` : '')};
  ${({ ml }) => (ml ? `margin-left: ${ml}` : '')};
  ${({ mr }) => (mr ? `margin-right: ${mr}` : '')};
`;
